import { styled } from "styled-components";
import { useSearchspringPLPContext } from "../../contexts/SearchspringPLPContext";
import { buttonReset, colors, font } from "../../lib/sharedStyles";

const Container = styled.div<{ $isOpen: boolean; }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (min-width: 1024px) {
    position: absolute;
    z-index: 11;
    left: 0;
    top: 32px;
    width: 250px;
    padding: 16px;
    border-radius: 2px;
    background: ${colors.fender.white};
    border: 1px solid ${colors.fender.grey03};
    opacity: 1;
    transition: opacity 300ms ease;

    ${({ $isOpen }) => !$isOpen && `
      opacity: 0;
      pointer-events: none;
    `}
  }
`;

const Option = styled.button`
  ${buttonReset()};
  display: flex;
  align-items: center;
  ${font('Instrument Sans', 400, '14px', '20px')};
  letter-spacing: 0.14px;
  color: ${colors.fender.primaryDark};
  margin-bottom: 8px;

  &:hover {
    text-decoration: underline;
  }

  span {
    display: flex;
    margin-right: 8px;
  }

  @media (min-width: 1024px) {
    ${font('Instrument Sans', 400, '12px', '28px')};
    letter-spacing: 0.12px;
    margin-bottom: 0;

    span {
      display: none;
    }
  }
`;

const PLPSortMenu = () => {
  const {
    activeSortOption,
    sortMenuOpen,
    sortOptions,
    sortPLP
  } = useSearchspringPLPContext();

  return (
    <Container $isOpen={sortMenuOpen}>
      {sortOptions.map(option => {
        let isActive = false;
        // Once sort is interacted with, we keep track of the active value in SearchspringPLPContext.
        if (activeSortOption) {
          if (`${option.field}-${option.direction}` == activeSortOption) {
            isActive = true;
          }
        } else if (option?.default) {
          // Before the user interacts with search, the default value from the API should show as active.
          isActive = true;
        }

        return (
          <Option onClick={() => sortPLP(option)} key={`${option.field}-${option.direction}`}>
            <span>
              {(isActive) ? (
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none"><rect width="15" height="15" x=".5" y=".5" fill="#191A1F" stroke="#191A1F" rx="7.5"/><rect width="6" height="6" x="5" y="5" fill="#fff" rx="3"/></svg>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none"><rect width="15" height="15" x=".5" y=".5" stroke="#595959" rx="7.5"/></svg>
              )}
            </span>
            {option.label}
          </Option>
        );
      })}
    </Container>
  );
}

export default PLPSortMenu;